if (!customElements.get('subscription-slider')) {
  class SubscriptionSlider extends HTMLElement {
    slider = {};
    settings = {
      slidesPerView: 1,
      rewind: true,
      arrows: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      breakpoints: {
        990: {
          slidesPerView: 2.2,
        },
      },
      arrows: true,
      navigation: {
        nextEl: '.slider-button-next',
        prevEl: '.slider-button-prev',
      },
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        scale: 0.7,
        slideShadows: false,
        depth: 0,
      },
      on: {
        realIndexChange: this.setSliderBackground.bind(this),
      },
    };
    sectionToUpdate = null;

    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector('.swiper'), this.settings);
      this.sectionToUpdate = this.closest('section').querySelector('.subscription-flow__body');
      this.setSliderBackground();

      if (this.sectionToUpdate) {
        this.slider.on('realIndexChange', () => this.updateSection());
      }

      const urlParams = new URLSearchParams(window.location.search);
      const productFromUrlParam = urlParams.get('product');
      if (!productFromUrlParam) return;
      const selectedSlide = this.querySelector(`[data-product-handle="${productFromUrlParam}"]`);

      // Swipe Swiper to selected slide
      if (selectedSlide) {
        const slideIndex = Array.from(this.querySelectorAll('.swiper-slide')).indexOf(
          selectedSlide,
        );
        if (slideIndex >= 0) {
          this.slider.slideTo(slideIndex);
        }
      }
    }

    setSliderBackground() {
      const activeSlide = this.slider.slides[this.slider.activeIndex];
      const bgColor = activeSlide.querySelector('[data-color]').getAttribute('data-color');

      this.style.backgroundColor = bgColor;
    }

    updateSection() {
      if (!this.sectionToUpdate) return;

      const activeSlide = this.slider.slides[this.slider.activeIndex];
      const productURL = activeSlide
        .querySelector('.subscription-product')
        .getAttribute('data-url');
      const fetchURL = productURL + '?section_id=subscription-flow-body';

      fetch(fetchURL)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('.subscription-flow__body');

          if (newContent) {
            this.sectionToUpdate.innerHTML = newContent.innerHTML;
          }
        });

      // Add product URL parameter based on the slide's data-product-handle attribute
      const productHandle = activeSlide.getAttribute('data-product-handle');
      const url = new URL(window.location);
      url.searchParams.set('product', productHandle);
      window.history.replaceState({}, '', url);
    }
  }
  customElements.define('subscription-slider', SubscriptionSlider);
}
